module.exports = __webpack_public_path__ + "static/notes-tab-app-cover-957902e967331110fdf640e98695aa2d.png";